<template>
	<div class="footer cl_white" id="vfooter">
		<div class="w1200">
			<div class="footer_top">
				<div class="footer_cont">
					<div class="footer_l">
						<ul>
							<li class="footer_list" v-for="(item,index) in article.cate_article" :key="index">
								<h3>{{item.name}}</h3>
								<p class="mat15" v-for="(item,index) in item.article" :key="index">
									<router-link :to="{ path: '/help_details', query: { id: item.id }}">{{item.name}}</router-link>
								</p>
							</li>
						</ul>
					</div>
					<div class="footer_r tc">
						<div class="footer_logo">
							<img :src="public.bottom_logo" />
						</div>
						<div class="footer_code mat15">
							<img :src="public.qr_code" />
						</div>
					</div>
				</div>
				<div class="footer_phone f36px mat25">
					<img src="../../static/phone.png" />
					<span>{{public.web_phone}}</span>
				</div>
			</div>
			<div class="footer_btm tc">
				<p>{{public.web_copyright}} | <a href="https://beian.miit.gov.cn/" target="_blank" class="cl_white">{{public.web_record}}</a></p>
				<p class="mat5">{{public.company_name}}</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	  name: 'vfooter',
	  props: {
	    
	  },
		data () {
			return {
				public: {},
				article: {},
			}
		},
		mounted() {
			
		},
		created() {
			this.getInfo();
			this.getArticle();
		},
		methods: {
			getInfo () {
				var that = this;
				that.$get("/api/base/get_base_configuration_data",{})
				.then(res => {
					that.public = res.data
					that.$emit("child-event", that.public)
				});
			},
			getArticle () {
				this.$get("/api/base/get_base_article_data",{})
				.then(res => {
					this.article = res.data;
					this.$emit("article-event", this.article);
				});
			},
		},
	}
</script>

<style>
</style>
